import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { locale as italian } from "../../../../../i18n/it";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { Router } from "@angular/router";
import { CustomerService } from "../../../../../modules/customer/customer.service";
import { AuthenticationService } from "../../../../../auth/service";
import nationsWithCodes from "app/auth/models/nations-with-codes";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICustomer } from "../../../customer.interface";
import { ICity } from "app/auth/models/cities";

@Component({
  selector: "app-customers-site-add-form",
  templateUrl: "./customers-site-add-form.component.html",
  styleUrls: ["./customers-site-add-form.component.scss"],
})
export class CustomersSiteAddFormComponent implements OnInit {
  public formGroup: FormGroup;
  public contentHeader: IContentHeader = null;
  public customers: ICustomer[] = [];
  private showErrors: boolean = false;
  public nationsWithCodes: { name: string; code: string }[] = nationsWithCodes;

  constructor(
    public _utilService: UtilsService,
    public _formBuilder: FormBuilder,
    public customerService: CustomerService,
    public _citiesService: CitiesService,
    public router: Router,
    public _authenticationService: AuthenticationService,
  ) {
    this.contentHeader = {
      headerTitle: "",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.CUSTOMERS,
            isLink: false,
          },
          {
            name: italian.data.MENU.CUSTOMERS_LOCATION,
            isLink: true,
            link: "/dashboard/customers-location",
          },
          {
            name: italian.data.ADD,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.formGroup = this._formBuilder.group({
      client: new FormControl("", [Validators.required, Validators.min(0)]),
      label: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      street: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      zipcode: new FormControl("", [Validators.required, Validators.minLength(4), Validators.maxLength(5)]),
      city: new FormControl("", [Validators.required, Validators.min(1)]),
      external_city: new FormControl(""),
      province: new FormControl("", [Validators.required, Validators.min(1)]),
      km: new FormControl(0, [Validators.required, Validators.min(0)]),
      external: new FormControl(false),
      country: new FormControl(null),
    });

    this.customers = await this.customerService.getCustomers();

    this.contentHeader.headerTitle = await this._utilService.translate("TITLES.ADD_SITE");
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  setAutoProvince() {
    const cityValue: number = this.formGroup.get("city").value;
    if (cityValue > 0) {
      const cityObj: ICity = this._citiesService.list.find((city: ICity) => city.id === cityValue);
      const province = this._citiesService.list.find((city: ICity) => city.initials === cityObj.initials && city.is_main === 1);
      this.formGroup.patchValue({ province: province.id });
    }
  }

  /*In caso di sede estera città zipcode e provincia saranno impostati e inviati a null*/
  manageExternalSite() {
    if (this.formGroup.value.external) {
      this.formGroup.patchValue({
        zipcode: null,
        city: null,
        province: null,
        km: 1,
      });
      this.formGroup.get("country").addValidators(Validators.required);
      this.formGroup.get("external_city").addValidators(Validators.required);
    } else {
      this.formGroup.patchValue({
        zipcode: null,
        city: null,
        province: null,
        km: null,
      });
      this.formGroup.get("country").clearValidators();
      this.formGroup.get("external_city").clearValidators();
    }
  }

  async add() {
    if (!this._authenticationService.hasCapability("create_customer_address")) {
      window.history.back();
      return false;
    }
    this.showErrors = true;
    // controllo valori
    if (!this.formGroup.value.external) {
      if (this.formGroup.invalid) {
        return false;
      }
    } else {
      if (!this.formGroup.value.client || !this.formGroup.value.label || !this.formGroup.value.street) {
        return false;
      }
    }

    this._utilService.showLoading();
    await this.customerService
      .addAddress(this.formGroup.value)
      .then(async (response) => {
        if (this.formGroup.value.km === 0) {
          await this.customerService
            .calculateDistanceForCustomerToUs(response.site_id)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_CALCULATE_DISTANCE_CUSTOMER" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_CALCULATE_DISTANCE" });
            });
        }
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_ADD_CUSTOMER_SITE" });
        await this.router.navigateByUrl("/dashboard/customers-location");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_ADD_CUSTOMER_SITE" });
      });
  }
}
